import React, { useState, useRef, useMemo,useEffect } from "react";
import JoditEditor from "jodit-react";
import {useForm} from "react-hook-form";
import api from "../../../api/api";
import { toast } from "react-toastify";



const NewsCreate = () => {
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [categories, setCategories] = useState([])
  const {register, handleSubmit} = useForm();
  // const [placeholder, setPlaceholder] = useState("Start Typing")

  useEffect(() => {
    api
      .get("/news/categories/")
      .then((response) => {
        console.log('response.data ',response.data);
        setCategories(response.data);
        console.log("wadhuwahduwand",categories)
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  }, []);
  
  
  
  const [config, setConfig] = useState({
    zIndex: 0,
    readonly: false,
    activeButtonsInReadOnly: ['source', 'fullsize', 'print', 'about'],
    toolbarButtonSize: 'middle',
    theme: 'default',
    enableDragAndDropFileToEditor: true,
    saveModeInCookie: false,
    spellcheck: true,
    editorCssClass: false,
    triggerChangeEvent: true,
    height: 400,
    direction: 'ltr',
    language: 'en',
    debugLanguage: false,
    i18n: 'en',
    tabIndex: -1,
    toolbar: true,
    enter: 'P',
    useSplitMode: false,
    colorPickerDefaultTab: 'background',
    imageDefaultWidth: 100,
    // imageDefaultHeight: 100,
    removeButtons: ['source', 'fullsize', 'about', 'outdent', 'indent', 'video', 'print', 'table', 'fontsize', 'superscript', 'subscript', 'file', 'cut', 'selectall'],
    disablePlugins: ['paste', 'stat'],
    events: {},
    textIcons: false,
    uploader: {
      insertImageAsBase64URI: true
    },
    placeholder: '',
    showXPathInStatusbar: false
  })

  const [thumbnail, setThumbnail] = useState([])


  const handleSub = (data) => {
    data.description = content
    const user = JSON.parse(localStorage.getItem("user"));
    data.author = user.user_id    
    // console.log(data)  
    data.thumbnail =  thumbnail

    api.post('/news/', data)
    .then(response=> {
       toast.success("Data registered successfull")
    }).catch(error=> {
      toast.error("Data Registeration failed")
    })
  }

  const handleThumbnail = (e) => {
    let reader = new FileReader();
    let baseURL = "";
    reader.readAsDataURL(e.target.files[0]);

    return new Promise((resolve) => {
      reader.onload = () =>{
        baseURL = reader.result

        setThumbnail(baseURL)
        resolve(baseURL)
      }
    })
    

  }



  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create News Post
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* table  */}
      <div className="mt-5 px-3 md:!px-10">
        <form className="" onSubmit={handleSubmit(handleSub)}>
          <div className="grid md:grid-cols-2 border-2 border-primary-blue ">
            {/* writer name */}
            <div className="border-primary-blue flex items-center gap-2 border-b-2 p-2">
              <label htmlFor="" className="text-primary-red">
                News Writer Name:
              </label>
              <input
                type="text"
                name=""
                {...register(`author_name`, {
                  // required : false
                })}

                className="flex-grow py-2 px-2 outline-none"
                id=""
                placeholder="News Writer Name"
              />
            </div>
            {/*News Poster Name */}
            {/* <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:!border-t-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                News Poster Name:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="News Poster Name"
              />
            </div> */}
            {/* News Heading */}
            <div className="border-primary-blue flex items-center gap-2 border-l-2 border-b-2  p-2">
              <label htmlFor="" className="text-primary-red">
                News Heading:
              </label>
              <input
                type="text"
                name=""
                {...register('title', {
                  // required : false
                })}
                className="flex-grow py-2 px-2 outline-none"
                placeholder="News Heading"
              />
            </div>
            {/* News Category */}
            <div className="border-primary-blue flex items-center gap-2 border-b-2 border-t-0 p-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red flex-shrink-0">
                News Category:
              </label>
              <select
                className="form-select m-0 block w-full appearance-none rounded border border-solid border-gray-300 bg-white bg-clip-padding bg-no-repeat px-3 py-1.5 text-base font-normal text-gray-700 transition ease-in-out focus:border-blue-600 focus:bg-white focus:text-gray-700 focus:outline-none"
                aria-label="Default select example"
                {...register("category", { required: false })} 

              >
                <option selected="" >select</option>

                {             
                 categories.map((item,i)=>{
                  return(
                    <>
              
                <option   value={item.id}>{item.name_nep}</option>
                    
                    </>
                  )
                 })
                }
            
              </select>
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-b-2 border-t-0 p-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red flex-shrink-0">
                News Category in Eng:
              </label>
              <select
                className="form-select m-0 block w-full appearance-none rounded border border-solid border-gray-300 bg-white bg-clip-padding bg-no-repeat px-3 py-1.5 text-base font-normal text-gray-700 transition ease-in-out focus:border-blue-600 focus:bg-white focus:text-gray-700 focus:outline-none"
                aria-label="Default select example"
                {...register("category", { required: false })} 

              >
                <option selected="" >select</option>

                {             
                 categories.map((item,i)=>{
                  console.log('category',item)
                  return(
                    <>
              
                <option   value={item.id}>{item.name_eng}</option>
                    
                    </>
                  )
                 })
                }
            
              </select>
            </div>
           
            <div className="border-primary-blue flex items-center gap-2  border-t-0 p-2">
              <label htmlFor="" className="text-primary-red">
                Thumbnail:
              </label>
              <input
                type="file"
                name=""
                // {...register('thumbnail', {
                //   // required : false
                // })}

                onChange={(e)=> handleThumbnail(e) }
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Thumbnail"
              />
            </div>
          </div>
          {/* upload phote */}
          {/* <div className="border-primary-blue items-center gap-2 border-2 border-t-0 p-1 md:flex">
            <label
              htmlFor=""
              className="text-primary-red flex-shrink-0 font-bold"
            >
              Upload Photos
            </label>
            <div className="flex flex-wrap items-center gap-4">
              <div className="flex flex-col items-center">
                <label className="text-primary-blue text-sm" htmlFor="">
                  Heading photo-1
                </label>
                <input
                  type="file"
                  name=""
                  className="text-primary-blue file:bg-primary-red ml-3 w-[200px] outline-none file:rounded-lg file:text-white"
                  id=""
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-primary-blue text-sm" htmlFor="">
                  Heading photo-2
                </label>
                <input
                  type="file"
                  name=""
                  className="text-primary-blue file:bg-primary-red ml-3 w-[200px] outline-none file:rounded-lg file:text-white"
                  id=""
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-primary-blue text-sm" htmlFor="">
                  Mid photo-1
                </label>
                <input
                  type="file"
                  name=""
                  className="text-primary-blue file:bg-primary-red ml-3 w-[200px] outline-none file:rounded-lg file:text-white"
                  id=""
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-primary-blue text-sm" htmlFor="">
                  Mid photo-2
                </label>
                <input
                  type="file"
                  name=""
                  className="text-primary-blue file:bg-primary-red ml-3 w-[200px] outline-none file:rounded-lg file:text-white"
                  id=""
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-primary-blue text-sm" htmlFor="">
                  Mid photo-3
                </label>
                <input
                  type="file"
                  name=""
                  className="text-primary-blue file:bg-primary-red ml-3 w-[200px] outline-none file:rounded-lg file:text-white"
                  id=""
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-primary-blue text-sm" htmlFor="">
                  footer photo-1
                </label>
                <input
                  type="file"
                  name=""
                  className="text-primary-blue file:bg-primary-red ml-3 w-[200px] outline-none file:rounded-lg file:text-white"
                  id=""
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-primary-blue text-sm" htmlFor="">
                  footer photo-2
                </label>
                <input
                  type="file"
                  name=""
                  className="text-primary-blue file:bg-primary-red ml-3 w-[200px] outline-none file:rounded-lg file:text-white"
                  id=""
                />
              </div>
            </div>
          </div> */}
          {/* news details */}
          <div className="mt-3">
          
          <JoditEditor
            ref={editor}
            value={content}
            config={config}
            tabIndex={4} // tabIndex of textarea
            onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
            onChange={(newContent) => {setContent(newContent)}}
            
          />
          </div>
        
          <div className="mb-10">
            {/* <a
              href=""
              className="bg-primary-green ml-10 mt-5 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
            >
              Save
            </a> */}
            {/* <a
              href=""
              className="bg-primary-blue ml-10 mt-5 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
            >
              Post
            </a> */}

            <button
             type="submit"
             className="bg-primary-blue ml-10 mt-5 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
            >
                Post
            </button>


          </div>
        </form>
      </div>
      {/* end table */}
      
    </div>
  );
};

export default NewsCreate;
